const TimeFormat = {
  en: {
    date: 'DD MMM YYYY',
    dates: 'DD MMM YYYY HH:mm',
  },
  zh: {
    date: 'YYYY-MM-DD',
    dates: 'YYYY-MM-DD HH:mm',
  },
  'zh-HK': {
    date: 'YYYY-MM-DD',
    dates: 'YYYY-MM-DD HH:mm',
  },
}

export {
  TimeFormat,
}


export const CUSTOM_METRICS = {
  Crash: {
    KEY: 'B_APP_SHOP_MANAGE_CRASH',
  },
}
